import type { FC } from 'react';

import { useRouter } from '@/hooks/useRouter';
import { paths } from '@/lib/paths';

import type { NewsPageType } from '../../types';
import ArticlePreview from '../Article/ArticlePreview';
import { getImgHeight } from './helper';

import * as S from './PinnedNews.styles';

interface PinnedNewsProps {
  pinnedNews: Array<NewsPageType | null>;
}

const PinnedNews: FC<PinnedNewsProps> = ({ pinnedNews }) => {
  const router = useRouter();

  const handleArticleClick = (slug: string | null | undefined) => {
    if (slug) {
      router.push(paths.newsArticle.asPath({ slug: slug }));
    }
  };

  const imgHeight = getImgHeight(pinnedNews.length);
  return (
    <S.Wrapper>
      <S.Container $columns={pinnedNews.length}>
        {pinnedNews.map((item) => (
          <S.ArticleCard
            key={item?.sys?.id}
            onClick={() => handleArticleClick(item?.slug)}
          >
            <ArticlePreview
              data={item}
              deskHeight={imgHeight.deskHeight}
              height={imgHeight.height}
            />
          </S.ArticleCard>
        ))}
      </S.Container>
    </S.Wrapper>
  );
};

export default PinnedNews;
